var map = {
	"./8.jpg": "of7W",
	"./Eye.svg": "Ooa9",
	"./default-user.png": "CEu6",
	"./editorplaceholder.png": "QcxB",
	"./fond-modal.jpg": "gIXy"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "g2Y0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*$
// module id = g2Y0
// module chunks = 1